import React, { useEffect, useState } from "react";
import { Route, Routes, BrowserRouter, useLocation, Navigate } from "react-router-dom";
import "./App.css";
import Home from "./component/Home/Home";
import Header from "./component/Header/Header";
import Logo from "./component/Splash/Logo";
import Salesheet from "./component/Salesheet/Salesheet";
import viewboardDetails from "./component/Home/viewboardDetails";
import { CountryRegionData } from "react-country-region-selector";
import OnboardScreen from "./component/OnboardScreen/OnboardScreen";
import { ChakraProvider, Flex } from "@chakra-ui/react";
import ReactGA from "react-ga4";
import { SaleSheetContextProvider } from "./component/SaleSheetSlide/SaleSheetContext";
function UsePageView() {
    const location = useLocation();
    useEffect(() => {
        ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_TOKEN);
    }, []);
    useEffect(() => {
        console.log("HI")
        ReactGA.send({
            hitType: "pageview",
            page: location.pathname,
            title: location.pathname,
        });
    }, [location]);

    return null;
}
function App() {
    const [countryList, setCountryList] = useState([]);

    useEffect(() => {
        console.log("hiiii");
    }, []);

    useEffect(() => {
        const options = CountryRegionData.map((country) => ({
            value: country[0],
            label: country[0],
        }));
        setCountryList(options);
    }, []);

    return (
        <SaleSheetContextProvider>
            <ChakraProvider>
                <BrowserRouter>
                    <Flex flexDirection="column" justifyContent="center">
                        <Header />

                        <UsePageView />
                        <Flex
                            className="hide-scorllbar"
                            w="100%"
                            h="auto"
                            overflow="hidden"
                            direction="column"
                        >
                            <Routes>
                                <Route
                                    path="/"
                                    element={
                                        <Home
                                            viewboardDetails={
                                                viewboardDetails.viewboard
                                            }
                                            countryList={countryList}
                                        />
                                    }
                                />
                            <Route
                                path="/allInOne"
                                element={
                                    <Home
                                        viewboardDetails={
                                            viewboardDetails.allInOne
                                        }
                                        countryList={countryList}
                                    />
                                }
                            />
                            <Route
                                path="/cde"
                                element={
                                    <Home
                                        viewboardDetails={
                                            viewboardDetails.CDE
                                        }
                                        countryList={countryList}
                                    />
                                }
                            />
                            <Route
                                path="/stand"
                                element={<Navigate to="/allInOne" replace />}
                            />

                                <Route
                                    path="/salesheet"
                                    element={<Salesheet />}
                                />
                                <Route path="/splash" element={<Logo />} />
                                <Route
                                    path="/help"
                                    element={<OnboardScreen />}
                                />
                            </Routes>
                        </Flex>
                    </Flex>
                    {/* </UsePageView> */}
                </BrowserRouter>
            </ChakraProvider>
        </SaleSheetContextProvider>
    );
}

export default App;
